import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../services/http.service';
import Swal from 'sweetalert2';
import { FunctionsService } from '../../services/functions.service';

@Component({
  selector: 'app-educations',
  templateUrl: './educations.component.html',
  styleUrls: ['./educations.component.scss']
})
export class EducationsComponent implements OnInit {

  isLoading: boolean = false;
  educationCategoriesList: any[] = [];
  educationList: any[] = [];
  category: any = null;
  
  constructor(private httpService: HttpService, public functionsService: FunctionsService) { }

  ngOnInit() {
    this.getEducationsCategories();
  }
  
  getEducationsCategories() {
    this.isLoading = true;

    this.httpService.getEducationsCategories().subscribe(
      (response: any) => {
        if (response.status == "success") {
          this.educationCategoriesList = response.data.list;
          this.getEducations(null);
        }
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  getEducations(category: any) {
    this.isLoading = true;

    this.httpService.getEducations(category).subscribe(
      (response: any) => {
        if (response.status == "success") {
          this.educationList = response.data.list;
          this.isLoading = false;
        }
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

}
